import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiContentService } from '../../api/api-content.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Location} from '@angular/common';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-regisdetail',
  templateUrl: './regisdetail.component.html',
  styleUrls: ['./regisdetail.component.css']
})
export class RegisdetailComponent implements OnInit {

  constructor(
    private route:ActivatedRoute,
		public contentService:ApiContentService,
    private fb: FormBuilder,  
    private router: Router,
    private _location: Location,
    private changeDetector : ChangeDetectorRef
  ) { }

  registerForm: FormGroup;
  // identity_birth: NgbDateStruct;
  submitted = false;
  refid = '';
  loadingIcon = {
    invalid: false
  };
  regis:any = {};
  identity_type: any = 1;
  identity_birth: any = { year: 1977, month: 1, day: 1 };
  fileData: File = null;
  previewUrl:any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  image:any;
  user:any = {
    img: ''
  }

  prospekindex:any
  id_type:any = []
  subscribe_type:any = []
  home_type:any = []
  home_status:any = []
  provinces:any = {}
  cities:any = {}
  districts:any = {}
  subdistricts:any = {}


  ngOnInit(): void {
    this.prospekindex = this.route.snapshot.params.prospekindex
    this.checkProspek(this.prospekindex);

    this.getIdtype()
    this.getSubscrbtype()
    this.getHometype()
    this.getHomestatus()
    this.getProvince('identity')
    this.getProvince('billing')
    
    this.registerForm = this.fb.group({
      identity_name: [''],
      identity_nationality: [''],
      identity_type: this.identity_type,
      identity_number: ['', Validators.minLength(16)],
      identity_gender: [''],
      identity_birth: this.identity_birth,
      identity_celular: ['', Validators.minLength(10)],
      identity_wa: ['', Validators.minLength(10)],
      identity_address: [''],
      identity_home_number: [''],
      identity_province: [''],
      identity_city: [''],
      identity_district: [''],
      identity_subdistrict: [''],
      identity_rw: [''],
      identity_rt: [''],
      identity_postal_code: ['', Validators.minLength(5)],
      identity_image: [''],
      billing_name: [''],
      billing_address: [''],
      billing_home_number: [''],
      billing_phone_number: ['', Validators.minLength(10)],
      billing_province: [''],
      billing_city: [''],
      billing_district: [''],
      billing_subdistrict: [''],
      billing_rw: [''],
      billing_rt: [''],
      billing_postal_code: ['', Validators.minLength(5)],
      subscribe_type: [''],
      home_type: [''],
      home_status: ['']
    });

    this.regis['identity_birth'] = this.identity_birth
    this.regis['identity_type'] = this.identity_type

    this.ngAfterViewChecked()
  }

  // mencegah error validasi radio click
  ngAfterViewChecked(){
    this.changeDetector.detectChanges();
  }

  getIdtype(){
    this.contentService.getIdtype()
      .subscribe((response: any) => {
        console.log(response)
        this.id_type = response.data
      }
    );
  }
  getSubscrbtype(){
    this.contentService.getSubscribetype()
      .subscribe((response: any) => {
        console.log(response)
        this.subscribe_type = response.data
      }
    );
  }
  getHometype(){

    this.contentService.getHometype()
      .subscribe((response: any) => {
        console.log(response)
        this.home_type = response.data
      }
    );
  }
  getHomestatus(){

    this.contentService.getHomestatus()
      .subscribe((response: any) => {
        console.log(response)
        this.home_status = response.data
      }
    );
  }

  getProvince(content:any){
    this.provinces[content] = []

    const params = {
      'country_id': 1,
      'show': 'all'
    }
    this.contentService.getProvince(params).subscribe((response:any) => {
      // console.log(response);f
      if (response.status) {

        this.provinces[content] = response.data;

      }
    });
  }

  getCity(content:any,provinceid:any){
    this.cities[content] = []

    const params = {
      'province_id': provinceid,
      'show': 'all'
    }
    this.contentService.getCity(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.cities[content] = response.data;

      }
    });
  }

  getDistrict(content:any,cityid:any){
    this.districts[content] = []

    const params = {
      'city_id': cityid,
      'show': 'all'
    }
    this.contentService.getDistrict(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.districts[content] = response.data;

      }
    });
  }

  getSubdistrict(content:any,districtid:any){
    this.subdistricts[content] = []

    const params = {
      'district_id': districtid,
      'show': 'all'
    }
    this.contentService.getSubdistrict(params).subscribe((response:any) => {
      console.log(response);
      if (response.status) {

        this.subdistricts[content] = response.data;

      }
    });
  }

  get f(){
    return this.registerForm.controls;
  }

  checkProspek(prospekindex:any){
    // console.log(prospekid);
    const params = {
      'prospekindex' : prospekindex
    }
    this.contentService.checkProspek(params).subscribe((response:any) => {
      if (response.status) {
        this.loadingIcon.invalid = false;

        // this.regis = response.data;
        // this.listProductiptv()

      }else{
        this.loadingIcon.invalid = true;
      }
    });
  }
  // checkAccount(accountid:any){
  //   // console.log(accountid);
  //   const params = {
  //     'accountid' : accountid
  //   }
  //   this.rest.checkAccount(params).subscribe((response:any) => {
  //     console.log(this.regis,response.data);
  //     if (response.status) {
  //       this.loadingIcon.invalid = false;

  //       this.regis = response.data;

  //     }else{
  //       this.loadingIcon.invalid = true;
  //     }
  //   });
  // }

  changeBase64($event:any) {
    this.fileData = <File>$event.target.files[0];
    this.preview();
    this.readThis($event.target);
  }

  preview() {
    // Show preview 
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();      
    reader.readAsDataURL(this.fileData); 
    reader.onload = (_event) => { 
      this.previewUrl = reader.result; 
    }
  }

  readThis(inputValue: any): void {
    var file:File = inputValue.files[0];
    var myReader:FileReader = new FileReader();

    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      this.image = myReader.result;
      // console.log(this.image)
    }
  }

  getInstal(){
    const params = {}
    params['prospekindex'] = this.prospekindex;

    this.contentService.getProspekinstal(params).subscribe((response:any) => {
      console.log(response);
      this.getProvince('billing')
      this.getCity('billing',response.data.province)
      this.getDistrict('billing',response.data.city)
      this.getSubdistrict('billing',response.data.district)
      this.regis.billing_name = response.data.name;
      this.regis.billing_address = response.data.address;
      this.regis.billing_home_number = response.data.home_number;
      this.regis.billing_phone_number = response.data.phone_number;
      this.regis.billing_province = response.data.province;
      this.regis.billing_city = response.data.city;
      this.regis.billing_district = response.data.district;
      this.regis.billing_subdistrict = response.data.subdistrict;
      this.regis.billing_rw = response.data.rw;
      this.regis.billing_rt = response.data.rt;
      this.regis.billing_postal_code = response.data.postal_code;
    });
  }

  getIdentity(){
    if ( this.regis.identity_province === undefined || this.regis.identity_province === null) {
      alert('Mohon isi formulir diatas terlebih dahulu!\nTerimakasih!')
    } else if (this.regis.identity_name === undefined || this.regis.identity_name === null) {
      alert('Mohon isi formulir diatas terlebih dahulu!\nTerimakasih!')
    } else {      
    this.getProvince('billing')
    this.getCity('billing',this.regis.identity_province)
    this.getDistrict('billing',this.regis.identity_city)
    this.getSubdistrict('billing',this.regis.identity_district)
    this.regis.billing_name         = this.regis.identity_name
    this.regis.billing_address      = this.regis.identity_address
    this.regis.billing_home_number  = this.regis.identity_home_number
    this.regis.billing_phone_number = this.regis.identity_celular
    this.regis.billing_rw           = this.regis.identity_rw
    this.regis.billing_rt           = this.regis.identity_rt
    this.regis.billing_postal_code  = this.regis.identity_postal_code
    this.regis.billing_province     = this.regis.identity_province
    this.regis.billing_city         = this.regis.identity_city
    this.regis.billing_district     = this.regis.identity_district
    this.regis.billing_subdistrict  = this.regis.identity_subdistrict
    }
  }
  
  getLainnya(){
    // this.registerForm.enabled
    this.regis.billing_name         = ''
    this.regis.billing_address      = ''
    this.regis.billing_home_number  = ''
    this.regis.billing_phone_number = ''
    this.regis.billing_rw           = ''
    this.regis.billing_rt           = ''
    this.regis.billing_postal_code  = ''
    this.regis.billing_province     = ''
    this.regis.billing_city         = ''
    this.regis.billing_district     = ''
    this.regis.billing_subdistrict  = ''
  }

  onNext(){
    this.submitted = true;
    
    if (this.registerForm.invalid) {
      return;
    }

    const params          = this.registerForm.value
    let month_birth_to    = params.identity_birth.month;
    let day_birth_to      = params.identity_birth.day;
    params.identity_image = this.image;
    params.identity_birth = params.identity_birth.year+
                            '-'+
                            (month_birth_to.toString().length == 1 ? ('0'+month_birth_to) : month_birth_to)+
                            '-'+
                            (day_birth_to.toString().length == 1 ? ('0'+day_birth_to) : day_birth_to)
    // params = this.registerForm.value
    params['prospekindex'] = this.prospekindex
    console.log(params);

    this.contentService.setProspekdetail(params).subscribe((response:any) => {
      console.log(response);
      if ( response.status ) {
        alert(response.message + "\nMohon selanjutnya isi paket yang anda inginkan\n\nTerimakasih!")
        this.router.navigate(['regis3/', this.prospekindex]);
      }else{
        alert(response.message)
      }
    });

  }

  backClicked() {
    const id = this.regis.accountidreferral
    this.router.navigate(['regis/', id]);
  }

  onReset(){
    this.submitted = false;
    this.registerForm.reset();
  }

}
